/**
 * @Description :
 */
import { useMethods } from '@lhb/hook';
import { Empty, Form, Select } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { debounce } from '@lhb/func';
import AMap from '@/common/components/AMap';
import { AimOutlined, SearchOutlined } from '@ant-design/icons';
import styles from './index.module.less';
/**
 * 逆地理编码(经纬度转换成具体地址)
 * @param {Array} lnglat 经纬度
 * @param {String} cityName 城市名
 * @param {Boolean} onlyAddress 是否仅返回具体地址
 */
export function getLngLatAddress(geocoder, lnglat, onlyAddress = true) {
  return new Promise((resolve, reject) => {
    geocoder.getAddress(lnglat, (status, result) => {
      if (status === 'complete' && result && result.regeocode) {
        const { regeocode } = result;
        if (onlyAddress) {
          const { formattedAddress } = regeocode || {};
          resolve(formattedAddress);
        } else {
          resolve(regeocode);
        }
      } else {
        reject(new Error(`根据经纬度查询地址失败`));
      }
    });
  });
}

const DynamicAddress: React.FC<any> = ({ value, onChange, selectRules, addressMessage }) => {
  const dynamicAdd:any = useRef(null);
  const [address, setAddress] = useState<string>();
  const [searchKey, setKey] = useState('');
  const [selectValue, setSelectValue] = useState<any>();
  const [options, setOptions] = useState<any[]>([]);
  const geocoder: any = useRef();
  const geolocation: any = useRef();
  const placeSearch: any = useRef();
  const autocomplete: any = useRef();

  const [amapIns, setAmapIns] = useState<any>(null); // 地图实例
  const marker = useRef<any>();

  const layout = {
    labelCol: {
      span: 6
    },
    wrapperCol: {
      span: 24
    }
  };

  const loadedMap = (_mapIns) => {
    window.AMap.plugin(['AMap.Geocoder', 'AMap.AutoComplete', 'AMap.PlaceSearch', 'AMap.Geolocation'], () => {
      // 默认全国
      const autoOptions = { city: '全国', extensions: 'all' };
      geocoder.current = new window.AMap.Geocoder(autoOptions);
      geolocation.current = new window.AMap.Geolocation();
      autocomplete.current = new window.AMap.AutoComplete(autoOptions);
      placeSearch.current = new window.AMap.PlaceSearch({
        panel: 'panel',
        autoFitView: true,
      });
      setAmapIns(_mapIns);
      _mapIns?.on('click', onClick);
      // setTimeout(() => {
      //   getLocation();
      // }, 0);
    });
  };
  const { onClick, onValueChange, updateMarker, getLocation, getAddress } = useMethods({
    onValueChange(val: any) {
      // (!val.address && !val.longitude && !val.latitude) && (val = undefined);
      onChange?.(val);
    },
    async onClick(e) {
      const { lng, lat } = e.lnglat;
      updateMarker(lng, lat);
      const { address, poiName, poiId } = await getAddress(e.lnglat);

      setAddress(address);
      onValueChange({
        address: address,
        longitude: e.lnglat.lng,
        latitude: e.lnglat.lat,
        poiName,
        poiId,
      });
    },
    onInputChange(e) {
      setAddress(e.target.value);
      onValueChange({ ...value, address: e.target.value, adcode: selectValue });
    },
    /* 更新marker */
    updateMarker(lng, lat) {
      if (!lng || !lat) { return; }
      marker.current?.remove();
      marker.current = new window.AMap.Marker({ position: [lng, lat] });
      marker.current && marker.current.setMap(amapIns);
      amapIns?.setFitView(
        [marker.current],
        false, null, 15);
    },
    getLocation(isSearch = true) {
      geolocation.current.getCurrentPosition(function(status, positionRes) {
        if (status !== 'complete') {
          window.microMessage.warning('定位失败，请重试');
          return;
        }
        if (status === 'complete' && positionRes.position) {
          const position = positionRes.position;
          const { lng, lat } = position;
          updateMarker(lng, lat);
          getLngLatAddress(geocoder.current, position, false).then((result: any) => {
            const { district, streetNumber, street } = result.addressComponent || {};
            const _address = result.pois?.[0].address || `${district}${street}${streetNumber}`; // 地址从poi里面取，如果没有就从addressComponent里取
            setAddress(_address);
            onValueChange({ address: _address, longitude: position.lng, latitude: position.lat, poiName: result.formattedAddress, poiId: result.pois?.[0].id });
          });
          if (isSearch) {
            // 获取详细地址 https://yapi.lanhanba.com/project/399/interface/api/47802
            getLngLatAddress(geocoder.current, position, false).then((res: any) => {
              handleSearch(res.address);
            });
          }
        }
      });
    },
    async getAddress(location) {
      let address:string = '';
      let poiName:string = '';
      let poiId:string|number = '';
      await getLngLatAddress(geocoder.current, location, false).then((result: any) => {
        const { formattedAddress, addressComponent, pois } = result || {};
        const { township, streetNumber, street, province, city, district } = addressComponent || {};
        poiName = formattedAddress;
        poiId = pois?.[0]?.id;
        // 如果街道和街道号存在就取
        if (streetNumber && street) {
          address = `${township}${street}${streetNumber}`;
          return;
        }

        let _formattedAddress:string = formattedAddress;
        [province, city, district].filter(Boolean).map(item => {
          if ((_formattedAddress).startsWith(item)) {
            _formattedAddress = _formattedAddress.replace(item, '');
          }
        });
        address = _formattedAddress;
        return;
      });

      return { address, poiName, poiId };
    }
  });

  useEffect(() => {
    const { latitude, longitude, address, poiName, poiId } = value || {};

    amapIns && updateMarker(longitude, latitude);

    if (address) {
      setAddress(address);
    };

    if (poiName && poiId) {
      setSelectValue(poiId);
      setOptions([{ label: poiName, value: poiId }]);
    }

    // eslint-disable-next-line
  }, [value, amapIns]);



  const handleSearch = debounce((value) => {
    setKey(value);
    autocomplete.current?.search(value, function (_status: string, result: any) {
      const addressResult: Array<any> = [];
      result?.tips?.forEach((item: any) => {
        if (item.id && typeof item.id === 'string') {
          addressResult.push({
            label: `${item.district}${item.name}`,
            value: item.id,
            adcode: item.adcode,
            location: item?.location
          });
        }
      });
      setOptions(addressResult);
    });
  }, 500);

  const handleChange = async(_, option) => {
    if (!option) {
      setAddress(undefined);
      return;
    }
    const { label, value, location } = option;

    setSelectValue(value);
    if (location) { // 如果有经纬度，用经纬度逆向地理编码获取地理是最准的
      const { lat, lng } = location;
      updateMarker(lng, lat);
      const { address } = await getAddress(location);

      setAddress(address);
      onValueChange({
        address,
        longitude: lng,
        latitude: lat,
        poiName: label,
        poiId: value,
      });
    } else { // 如果没有经纬度，用地理名正向地理编码查一遍后再用经纬度去查位置
      geocoder.current.getLocation(label, async (status, result) => {
        if (status === 'complete' && result.info === 'OK') {
          // result中对应详细地理坐标信息
          const { geocodes = [] } = result;
          const { location = {}, } = geocodes[0] || {};
          const { lat, lng } = location;

          updateMarker(lng, lat);

          const { address } = await getAddress(location);

          setAddress(address);
          onValueChange({
            address,
            longitude: lng,
            latitude: lat,
            poiName: label,
            poiId: value,
          });

        }
      });
    }
  };

  const onClear = () => {
    setSelectValue(undefined);
    setAddress(undefined);
    onChange?.(undefined);
  };

  useEffect(() => {
    if (value && value.longitude) {
      updateMarker(value?.longitude, value?.latitude);
    }
    if (value && value.address) {
      setAddress(value?.address);
    }

    // eslint-disable-next-line
  }, [value]);

  return (
    <div
      ref={dynamicAdd}
      className={styles[`dynamic-address`]}
    >
      <Form.Item rules={selectRules} {...layout}>
        <div style={{ width: '100%', height: '300px' }}>
          <AMap
            mapOpts={{ zoom: 15, resizeEnable: true }}
            loaded={loadedMap}
          />
          <div className={styles[`position-btn`]} onClick={() => getLocation(false)}>
            {/* <IconFont iconHref='res-mobile-icon-orientation'/> */}
            <AimOutlined className={styles[`position-icon`]} />
          </div>
          <Select
            className={styles[`address-select`]}
            showSearch
            onSearch={handleSearch}
            onClear={onClear}
            filterOption={false}
            value={selectValue} // poiId
            onChange={handleChange}
            placeholder='请输入搜索位置'
            notFoundContent={searchKey ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} /> : null}
            allowClear
            // labelInValue={true}
            popupClassName={styles[`address-select-popup`]}
            getPopupContainer={() => {
              const target:any = dynamicAdd.current || document.body;
              return target;
            }}
            options={options}
            suffixIcon={<SearchOutlined/>}
          />
        </div>
      </Form.Item>
      <Form.Item {...layout} label='' colon={false} style={{ marginTop: -20, marginBottom: -6, display: 'none' }}>
        {address}
      </Form.Item>
      {addressMessage && <Form.Item {...layout} label='' colon={false} style={{ marginTop: -10, marginBottom: -6, color: 'red' }}>
        {addressMessage}
      </Form.Item>}
    </div>
  );
};
export default DynamicAddress;
